/**
 * @flow
 */

import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import { Box, Button, FormHelperText, IconButton, SvgIcon } from '@mui/material';
import TextField from 'components/formik/TextField';
import { FastField, FieldArray } from 'formik';
import React from 'react';
import { I18n } from 'utils/i18n';

type Props = {
  field: { name: string, value: Array<string> },
  form: Object,
  add?: string,
  remove?: string,
  itemComponent?: any,
  filter?: Array<any>,
  filterOut?: Array<any>,
};

const ListField = ({
  field,
  form,
  add = null,
  remove = null,
  itemComponent = TextField,
  filter,
  filterOut,
}: Props) => {
  const { name, value } = field;
  const fieldMeta = form.getFieldMeta(name);
  const { touched } = fieldMeta;
  let { error } = fieldMeta;
  if (typeof error !== 'string') {
    // Don't show children errors
    error = null;
  }
  return (
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <div>
          {value && value.length > 0
            ? value.map((itemValue, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    mb: 1,
                    alignItems: 'center',
                  }}
                >
                  <FastField
                    component={itemComponent}
                    name={`${name}.${index}`}
                    filter={filter}
                    filterOut={filterOut}
                  />
                  <IconButton
                    sx={{ ml: 1, color: 'primary.main' }}
                    size="small"
                    onClick={() => arrayHelpers.remove(index)}
                    title={remove || I18n.t('ListField.Remove')}
                  >
                    <Delete fontSize="inherit" />
                  </IconButton>
                </Box>
              ))
            : null}
          <Button
            sx={{ mt: 1 }}
            size="small"
            variant="outlined"
            onClick={() => arrayHelpers.push('')}
            disableElevation
          >
            <SvgIcon
              sx={{
                fontSize: 18,
                mr: '5px',
                color: 'primary.main',
              }}
            >
              <Add />
            </SvgIcon>
            {add || I18n.t('ListField.Add')}
          </Button>
          {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </div>
      )}
    />
  );
};

export default ListField;
